/** Query keys for remote data. Local cards stay in IndexedDB and are not cached here. */
export const queryKeys = {
  session: ['session'],
  backups: (userId) => ['backups', userId],
};
